<template>
  <div>
    <a-input placeholder="序列号" disabled = "true" style="width:400px;color:black" v-model="sn"/>
  
    <a-select default-value="1" style="width: 120px" @change="handleChange">
      <a-select-option value="1">
        试用
      </a-select-option>
      <a-select-option value="0">
        永久
      </a-select-option>
    </a-select>
    <a-input placeholder="激活码" disabled = "true" style="width:400px;color:black" v-model="activecode"/>
    <a-button type="primary" @click = "getactive">
      获取
    </a-button>
    <div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  
    <p>LDH13_AKS,LDHKZ36,LDH13_TTJ激活（即可定时限）</p>
    <a-input placeholder="激活时限（如：20230101）" style="width:400px;color:black" v-model="deadline"/>
    
    <a-select default-value="1" style="width: 120px" @change="handleChange1">
      <a-select-option value="1">
        试用
      </a-select-option>
      <a-select-option value="0">
        永久
      </a-select-option>
    </a-select>
    <a-input placeholder="激活码" disabled = "true" style="width:400px;color:black" v-model="activecode1"/>
    <a-button type="primary" @click = "getactive1">
      获取
    </a-button>
    <a-button type="primary" @click = "toqxwl">
      千寻分配
    </a-button>
    </div>
    <div class="backbtn">
        <a-button type="primary" @click = "goback">
          返回
          </a-button>
      </div>
  </div>
  
</template>
<script>
export default {
    data(){
        
        return {
            sn:this.$store.state.terminalid,
            selected:1,
            selected1:1,
            activecode1:"",
            deadline:"",
            activecode:""
        };
    },
  methods: {
    handleChange(value) {
        this.selected = value
      console.log(`selected ${value}`);
    },
    handleChange1(value) {
        this.selected1 = value
      console.log(`selected1 ${value}`);
    },
    goback(){
        this.$store.state.terminalid=""
        this.$router.push('/home/terminallist')
    },
    
    toqxwl(){
      this.$router.push('/home/newterminal')
    },
    getactive(){
        let param = {
              sn:this.$store.state.terminalid,
              type:this.selected
            }
                         
        let obj = this.$qs.stringify(param)
            this.$axios({
                method:'post',
                url:'/api/terminal/getactive',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              let result = response.data
              if(result["result"])
              {
                this.activecode = result["message"]
              }

                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                
            })
        },
        getactive1(){
        let param = {
              sn:this.$store.state.terminalid,
              type:this.selected1,
              deadline:this.deadline 
            }
           
              
        let obj = this.$qs.stringify(param)
            this.$axios({
                method:'post',
                url:'/api/terminal/getldh13active',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              let result = response.data
              if(result["result"])
              {
                this.activecode1 = result["message"]
              }

                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                
            })
    },
    
    },
    
  }
</script>
<style scoped>
    .backbtn{
        margin-top: 50px;
        
    }
</style>





// WEBPACK FOOTER //
// src/components/TerminalActive.vue